import { render, staticRenderFns } from "./FollowUpPatientStep2Component.vue?vue&type=template&id=3a641351&scoped=true&"
import script from "./FollowUpPatientStep2Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep2Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep2Component.vue?vue&type=style&index=0&id=3a641351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a641351",
  null
  
)

export default component.exports